import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type { APIResponse, MatterIntakeTemplate } from "@/lib/types";

export const createMatterIntakeTemplateV1 = async (
  data: Pick<MatterIntakeTemplate, "label"> & Partial<MatterIntakeTemplate>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterIntakeTemplate>
    >(`${baseFastApiMatterRoute}/intake-templates`, data)
    .then((res) => res.data);
};

export const updateMatterIntakeTemplateV1 = async (
  data: Pick<MatterIntakeTemplate, "id" | "dateModified"> &
    Partial<MatterIntakeTemplate>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterIntakeTemplate>
    >(`${baseFastApiMatterRoute}/intake-templates`, data)
    .then((res) => res.data);
};

export const deleteMatterIntakeTemplateV1 = async (id: string) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterIntakeTemplate>
    >(`${baseFastApiMatterRoute}/intake-templates/${id}`)
    .then((res) => res.data);
};
